import { useThunkDispatch } from "../../store";
import {
    fetchDatasourceByName,
    refreshDatasourceByName,
    patchDatasourceData,
    setDatasourceData,
    updateParameterValue,
    setDefaultParameterValue,
    updateCurrentCanvasState,
} from "../../store/storyline/actions";
import {
    showError,
    showSuccess,
    showDetailedError,
    showWarning,
    showInfo,
} from "../../store/notifications/actions";
import { useMemo } from "react";

/**
 * A hook which provides access to all the actions available to plugins.
 * 
 * For convenience, the returned functions are wrapped in a `dispatch` call and can be called directly.
 * 
 * @returns An object containing all the dispatched actions for the application.
 */
export const useAppActions = () => {
    const dispatch = useThunkDispatch();
    const dispatchedActions = useMemo(() => ({
        updateParameterValue: (...params: Parameters<typeof updateParameterValue>) => dispatch(updateParameterValue(...params)),
        setDefaultParameterValue: (...params: Parameters<typeof setDefaultParameterValue>) => dispatch(setDefaultParameterValue(...params)),
        updateCurrentCanvasState: (...params: Parameters<typeof updateCurrentCanvasState>) => dispatch(updateCurrentCanvasState(...params)),

        fetchDatasourceByName: (...params: Parameters<typeof fetchDatasourceByName>) => dispatch(fetchDatasourceByName(...params)),
        refreshDatasourceByName: (...params: Parameters<typeof refreshDatasourceByName>) => dispatch(refreshDatasourceByName(...params)),
        setDatasourceData: (...params: Parameters<typeof setDatasourceData>) => dispatch(setDatasourceData(...params)),
        patchDatasourceData: (...params: Parameters<typeof patchDatasourceData>) => dispatch(patchDatasourceData(...params)),

        showSuccess: (...params: Parameters<typeof showSuccess>) => dispatch(showSuccess(...params)),
        showInfo: (...params: Parameters<typeof showInfo>) => dispatch(showInfo(...params)),
        showWarning: (...params: Parameters<typeof showWarning>) => dispatch(showWarning(...params)),
        showError: (...params: Parameters<typeof showError>) => dispatch(showError(...params)),
        showDetailedError: (...params: Parameters<typeof showDetailedError>) => dispatch(showDetailedError(...params)),
    }), [dispatch]);

    return dispatchedActions;
}